<img *ngIf="showHeader" class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>

<mat-card class="simple-card mx-auto mb-5">
  <mat-card-content>
    <div class="row">

      <div class="col-12 my-2 d-flex justify-content-between" *ngIf="showHeader">
        <h1>Reporte RegCheq</h1>
        <button mat-flat-button 
          class="custom-button-primary no-print"
          [printTitle]='"Regcheq_"+(rut | rutFormat)+"_"+today'
          [useExistingCss]="true"
          printSectionId="print-section"
          ngxPrint
        >
          <mat-icon 
            aria-hidden="false" 
            aria-label="Icono de descarga" 
            fontIcon="get_app" 
            class="icon-download"
          ></mat-icon>
          Descargar Resultado
        </button>
      </div>

      <div class="col-sm-12 col-md-11 col-lg-9 mx-auto my-2" *ngIf="showHeader">
        <mat-chip-set aria-label="Rut principal">
          <mat-chip class="chip-rut"><strong>RUT:</strong> {{rut | rutFormat}}</mat-chip>
        </mat-chip-set>
      </div>

      <div class="col-sm-12 col-md-11 col-lg-9 mx-auto my-3">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="font-size-title-card">
              <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
              <strong>Información Búscada</strong>
            </mat-card-title>
          </mat-card-header>
        
          <mat-card-content>

            <div class="row p-5">
              <div class="col-sm-12 col-md-9 col-lg-7">
                <div class="row">
                  <div class="col-12 my-2 pl-5">
                    <span>
                      <strong>Última Actualización:</strong> {{informacionBuscada?.ultimaActualizacion | date: 'dd-MM-yyyy'}}
                    </span>
                  </div>
                  <div class="col-12 my-2 pl-5" *ngIf="informacionBuscada?.nombre">
                    <span>
                      <strong>Nombre:</strong> {{informacionBuscada?.nombre}}
                    </span>
                  </div>
                  <div class="col-12 my-2 pl-5">
                    <span>
                      <strong>Tipo Persona:</strong> {{informacionBuscada?.tipoPersona}}
                    </span>
                  </div>
                  <div class="col-12 my-2 pl-5">
                    <span>
                      <strong>País:</strong> {{informacionBuscada?.pais || ''}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-5 d-flex justify-content-center">
                <mat-chip class="{{getRiskClass(informacionBuscada?.riesgo)}}">{{riskMapping(informacionBuscada?.riesgo)}}</mat-chip>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-sm-12 col-md-11 col-lg-9 mx-auto my-3">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="font-size-title-card">
              <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
              <strong>Listado de sanciones</strong>
            </mat-card-title>
          </mat-card-header>
        
          <mat-card-content>

            <div class="row p-5">
              <div class="col-sm-12 col-md-9 col-lg-7">
                <div class="row">
                  <div class="col-12 my-2 d-flex align-items-center" *ngFor="let sancion of listadoSanciones">
                    <div class="circulo mr-3" [ngClass]="sancion?.class"></div>
                    {{sancion?.displayName || ''}}
                    <button 
                      mat-mini-fab color="primary" 
                      aria-label="Boton apertura de seccion" 
                      class="smaller-mini-fab shadow-none ml-3 no-print" 
                      *ngIf="sancion?.hasButton"
                      (click)="addContentShow(sancion?.name)"
                    >
                      <mat-icon>play_arrow</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-5 d-flex justify-content-center">
                <button mat-flat-button 
                  class="custom-button-primary-container no-print"
                  (click)="showAllSanciones()"
                >
                  {{validateAllDetailsShow() ? 'Ocultar' : 'Ver'}} todos
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <ng-container *ngIf="sancionesDetails && sancionesDetails.length > 0">
        <ng-container *ngFor="let item of sancionesDetails">
          <div class="col-sm-12 col-md-11 col-lg-9 mx-auto my-3" [ngClass]="[validateContentShow(item?.id) ? 'showContent in active': 'div-print']">
            <mat-card [id]="item?.id">
              <mat-card-header>
                <mat-card-title class="font-size-title-card d-flex align-items-center">
                  <div class="circulo mr-3" [ngClass]="item?.riesgoClass"></div>
                  <strong>{{item?.titulo}}</strong>
                </mat-card-title>
              </mat-card-header>
            
              <mat-card-content>
                <div class="row p-5">
  
                  <div class="col-sm-12 col-md-10 mx-auto border">
                    <div class="table-responsive border-0">
                      <table mat-table [dataSource]="item?.tablaBasica" class="info-basica-table">
                        <ng-container matColumnDef="name">
                          <th mat-cell *matCellDef="let element" class="cell-font-size">{{element.name}}</th>
                        </ng-container>
                      
                        <ng-container matColumnDef="value">
                          <td mat-cell *matCellDef="let element" class="cell-font-size">
                            <ng-container [ngSwitch]="element.name">
                              <ng-container *ngSwitchCase="'Rut'">
                                {{element.value ? (element.value | rutFormat) : ''}}
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                {{element.value}}
                              </ng-container>
                            </ng-container>
                          </td>
                        </ng-container>
                      
                        <tr
                          mat-row
                          *matRowDef="let row; columns: displayedColumns;"
                        ></tr>
                      </table>
                    </div>
                  </div>
  
                  <div class="col-sm-12 col-md-10 px-0 mt-4 mb-2 mx-auto">
                    <div class="table-responsive">
                      <table mat-table [dataSource]="item.tabla.content" class="border">
                        <ng-container [matColumnDef]="column" *ngFor="let column of item.tabla.displayColumns; let indexButton = index">
                          <th mat-header-cell *matHeaderCellDef> {{item.tabla.titleTable[indexButton]}} </th>
                          <td mat-cell *matCellDef="let element"> {{column == 'rut' ? (element[column] | rutFormat) : element[column]}} </td>
                        </ng-container>
                      
                        <tr mat-header-row *matHeaderRowDef="item.tabla.displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: item.tabla.displayColumns;"></tr>
                      </table>
                    </div>
                  </div>
  
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </ng-container>
      </ng-container>

    </div>
  </mat-card-content>
</mat-card>
